export default __webpack_public_path__ + "static/media/close-icon.201b1dbd.svg";